import {
    BaseSectionWithBlocks,
    IFeatureContentBlockApiModel,
    ISectionBasedProps,
    SectionType,
} from '@app/models/common/common';

/**
 * Варианты, для разделения функционала платформы
 */
export enum TechnologiesFeatureType {
	Investor = 'investor',
	Borrower = 'borrower',
}

/**
 * Маппинг для отображения названий
 */
export const TechnologiesFeatureTypeMap: Record<TechnologiesFeatureType, string> = {
    [TechnologiesFeatureType.Investor]: 'Инвестору',
    [TechnologiesFeatureType.Borrower]: 'Заемщику',
};

/**
 * Интерфейс для работы с FeatureContentBlock внутри страницы technologies
 */
export interface ITechnologiesFeatureContentBlockApiModel extends IFeatureContentBlockApiModel {
	value?: TechnologiesFeatureType;
}

/**
 * Тип для отображения правильно варианта FeatureContentBlock
 */
export type TechnologiesFeatureBlockVariant = 'legal' | 'functional'

/**
 * Типы для работы с секциями и блоками для Feature блоков
 */
export type TechnologiesFeaturesWithBlocksSectionType = BaseSectionWithBlocks<ITechnologiesFeatureContentBlockApiModel, SectionType.FEATURES>
export type TechnologiesFeatureSectionType = ISectionBasedProps<TechnologiesFeaturesWithBlocksSectionType>

/**
 * Интерфейс инструмента
 */
export interface IInstrument {
	/**
	 * Ссылка на иконку
	 */
	image: string;

	/**
	 * Название инструмента
	 */
	title: string;
}

/**
 * Интерфейс блока с инструментами
 */
export interface ITechnologiesInstrumentsApiModel {
	/**
	 * Заголовок блока
	 */
	title: string;

	/**
	 * Список используемых инструментов
	 */
	instruments: IInstrument[];
}

/**
 * Типы для работы с секциями и блоками для блока инструментов
 */
export type TechnologiesInstrumentsSectionWithBlockType = BaseSectionWithBlocks<ITechnologiesInstrumentsApiModel, SectionType.INSTRUMENTS>
export type TechnologiesInstrumentsSectionType = ISectionBasedProps<TechnologiesInstrumentsSectionWithBlockType>
